import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {AlgoliaManager} from 'src/app/data/manager/algolia/algolia.manager';
import {PrimeManager} from 'src/app/data/manager/prime/prime.manager';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';
import {GoogleTagService} from 'src/app/data/networking/services/shared/google-tag/google-tag.service';
import {ProductInterface} from 'src/app/data/networking/models/shared/responses/product-response';
import {AddressInterface} from 'src/app/data/networking/models/customer/requests/address';
import {SaveNonStockItemRes} from 'src/app/data/networking/models/customer/responses/save-non-stock-item-res';
import {Customer} from 'src/app/data/networking/models/customer/customer';
import {DeliveryTypeEnum} from 'src/app/data/networking/models/location/enum/delivery-type.enum';
import {CustomerManager} from 'src/app/data/manager/customer/customer/customer.manager';
import {OrderManager} from 'src/app/data/manager/order/order/order.manager';
import {DeliveryTypeTimeResponse} from 'src/app/data/networking/models/delivery-type-time/delivery-type-time.model';
import {UpdateCartEvent} from 'src/app/ui/shared/event-listeners/update-cart/update-cart.event';
import {CartRes} from 'src/app/data/networking/models/cart/responses/cart-res';
import {SessionStorageManager} from '../../data/manager/session-storage/session-storage.manager';
import {CartManager} from '../../data/manager/cart/cart.manager';
import {SasCartManager} from '../../data/manager-v3/sas-subscription/sas-cart/sas-cart.manager';
import {ConfigurationManager} from '../../data/manager/configuration/configuration.manager';

@Injectable({
  providedIn: 'root',
})
export class ProductCardVm {
  public customer;
  constructor(private cartManager: CartManager,
    public algoliaManager: AlgoliaManager,
    private ssm: SessionStorageManager,
    private configurationManager: ConfigurationManager,
    private sasCartManager: SasCartManager,
    private primeManager : PrimeManager,
    private lsm: LocalStorageManager,
    private gtmService: GoogleTagService,
    private customerManager: CustomerManager,
    private orderManager: OrderManager,
    private updateCartEvent: UpdateCartEvent,
  ) {}

  getDeliveryType() {
      if(this.ssm.get('city')){
        return this.ssm.get('city').deliveryType; 
      }
  }

  updateQuantity(data): Observable<any> {
    return this.cartManager.addProduct(data);
  }

  removeProduct(productId): Observable<any> {
    return this.cartManager.removeProduct(productId);
  }

  updateSasQuantity(data): Observable<any> {
    data = {
      ...data,
    };
    return this.sasCartManager.createDetail(data);
  }

  removeSasProduct(data): Observable<any> {
    return this.sasCartManager.removeSasProduct(data);
  }

  isSasEnabled() {
    return this.sasCartManager.isSasEnabled();
  }

  setGtmList(list) {
    this.ssm.set('productGtmList', list);
  }

  getConfigurationModules(): any {
    return this.configurationManager.getConfigurationModule('productInformation');
  }

  getPrimeSubscription():Observable<any>{
    if(this.lsm.get("customer")){
      this.customer = this.lsm.get("customer");
      if(this.customer.id){
        return this.primeManager.getPrimeSubscription(this.customer.id);
      }
      return of({"active": false,})
    }else{
      const id = 0;
      return this.primeManager.getPrimeSubscription(id);
    }
  }

  getPropertiesAlgolia(prop): Observable<any> {
    return this.algoliaManager.getPropertiesAlgolia(prop);
  }
  getAgile(): Observable<any> {
    return this.cartManager.getAgile(true);
  }
  callGtmService(product:ProductInterface, list:string):void{
    return this.gtmService.onClickProduct(product, list, 'clickmenu');
  }
  getCity(): AddressInterface{
    return this.ssm.get('city');
  }
  gtmSuscribe(idConcat:string): void{
    this.gtmService.onSubscribeAvailable(idConcat);
  }
  getCustomer():Customer{
    return this.lsm.get('customer');
  }
  getDeliveryTimeGeneric(deliveryType: string): string{
    const limit = deliveryType === DeliveryTypeEnum.ENVIALOYA ? 12 : 7
    const deliveryLabel = this.ssm.get('deliveryTypeText')?.deliveryTimeLabelGeneric[deliveryType] || '5 días';
    return deliveryLabel?.substring(0, limit);
  }

  saveNonStockItem(email: string, itemId: string): Observable<SaveNonStockItemRes> {
    const data = {
      email,
      itemId,
    }

    return this.customerManager.saveNonStockItem(data);
  }

  removeNonStockItem(email: string, itemId: string): Observable<SaveNonStockItemRes> {
    const data = {
      email,
      itemId,
    }

    return this.customerManager.removeNonStockItem(data);
  }

  getItemLocalStorage(key: string) {
    return this.lsm.get(key);
  }

  setItemLocalStorage(key: string, value: any) {
    return this.lsm.set(key, value);
  }

  getDeliveryTypeTime(): Observable<DeliveryTypeTimeResponse> {
    return this.orderManager.getDeliveryTypeTime();
  }

  updatedAgileCart(): Observable<CartRes> {
    return this.updateCartEvent.updatedAgileCart;
  }
}
